import { url } from '@/config'
import ajax from '@/utils/request'

export const getChances = () => ajax(url.chances, {
  params: {
    channel: 'laohuji001'
  }
})

export const getMyPrize = () => ajax(url.myPrize, {
  params: {
    channel: 'laohuji001'
  }
})

export const lottery = () => ajax(url.lottery, {
  params: {
    channel: 'laohuji001'
  }
})
